import { hasDigits } from "@/utils/query";
import { today, tomorrow } from "@/utils/date";
import { protectedRoutes } from "@/routing";

export const generateLoadboardUrl = ({
  trailerType,
  pickup,
  pickupQuery,
  delivery,
  deliveryQuery,
  pickupDate,
  deliveryDate,
  pickupRadius,
  pickupMarket,
}) => {
  const queryParams = new URLSearchParams({
    trailerType: trailerType?.id,
    pickupZip: pickup?.zip,
    pickupPlaceName: pickup?.placeName,
    pickupStateCode: pickup?.stateCode,
    pickupWithZip: hasDigits(pickupQuery),
    pickupRadius: pickupRadius?.id || null,
    ...(delivery
      ? {
          deliveryZip: delivery?.zip || "",
          deliveryPlaceName: delivery?.placeName || "",
          deliveryStateCode: delivery?.stateCode || "",
          deliveryWithZip: hasDigits(deliveryQuery),
        }
      : {}),
    ...(pickupDate ? { pickupDate: pickupDate || today } : {}),
    ...(deliveryDate ? { deliveryDate: deliveryDate || tomorrow } : {}),
    ...(pickupMarket ? { pickupMarket } : {}),
  }).toString();

  return `${protectedRoutes[6].path}?${queryParams}`;
};

export const generateLoadRatesUrl = ({
  trailerType,
  pickup,
  pickupQuery,
  delivery,
  deliveryQuery,
  pickupDate,
  deliveryDate,
  outboundRatio,
  volume,
  outboundDuration,
}) => {
  if (!trailerType || !pickup || !delivery) return "#";

  const queryParams = new URLSearchParams({
    trailerType: trailerType.id,
    pickupZip: pickup.zip,
    pickupPlaceName: pickup.placeName,
    pickupStateCode: pickup.stateCode,
    pickupWithZip: hasDigits(pickupQuery),
    deliveryZip: delivery.zip || "",
    deliveryPlaceName: delivery.placeName || "",
    deliveryStateCode: delivery.stateCode || "",
    deliveryWithZip: hasDigits(deliveryQuery),
    ...(pickupDate ? { pickupDate: pickupDate || today } : {}),
    ...(deliveryDate ? { deliveryDate: deliveryDate || tomorrow } : {}),
    ...(outboundRatio ? { outboundRatio } : {}),
    ...(volume ? { volume } : {}),
    ...(outboundDuration ? { outboundDuration } : {}),
  }).toString();

  return `${protectedRoutes[1].path}?${queryParams}`;
};

export const generateMarketPotentialUrl = ({ trailerType, pickup, pickupQuery, pickupDate, outboundRatio, volume, outboundDuration }) => {
  if (!trailerType || !pickup) return "#";

  const queryParams = new URLSearchParams({
    trailerType: trailerType.id,
    pickupZip: pickup.zip,
    pickupPlaceName: pickup.placeName,
    pickupStateCode: pickup.stateCode,
    pickupWithZip: hasDigits(pickupQuery),
    ...(pickupDate ? { pickupDate: pickupDate || today } : {}),
    ...(outboundRatio ? { outboundRatio } : {}),
    ...(volume ? { volume } : {}),
    ...(outboundDuration ? { outboundDuration } : {}),
  }).toString();

  return `${protectedRoutes[2].path}?${queryParams}`;
};
